/**
 * Program 12.1 Wave 3 — EPC estimation cost groups (canonical list).
 * Keep in sync with backend/src/modules/epc/commercial/epc-cost-groups.ts
 */
export const EPC_COST_GROUPS = [
  'Engineering',
  'Major Equipment',
  'Bulk Materials',
  'Fabrication',
  'Construction Labour',
  'Construction Equipment',
  'Subcontracts',
  'Temporary Facilities',
  'Mobilization',
  'Demobilization',
  'Testing',
  'Commissioning',
  'Logistics',
  'Customs',
  'Insurance',
  'Bonds',
  'Site Overheads',
  'Corporate Overheads',
  'Contingency',
  'Escalation',
  'Risk Allowance',
  'Tax / Duties',
  'Warranty',
] as const;

export type EpcCostGroup = (typeof EPC_COST_GROUPS)[number];

export const EPC_COST_GROUP_OPTIONS = EPC_COST_GROUPS.map((g) => ({
  value: g,
  label: g,
}));
